'use client';
import SectionPage from "@/components/common/section-page";

import {Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList,} from "@/components/ui/breadcrumb"
import CardTitle from "@/components/common/card-title";
import AwesomeCard from "@/components/common/awesome-card";
import ImageGallery from "@/components/common/image-gallery";

export default function Home() {

    return (
        <div className={"flex flex-col gap-6 pb-6 bg-slate-100"}>
            <CardTitle title={"Affaires"}
                       backgroundImgSrc={"/images/card-title/Banniere-Affaire-copie.jpg"}/>

            {/* Breadcrumb */}
            <SectionPage sectionType="2xl">
                <div className={"flex justify-between items-center"}>
                    <Breadcrumb>
                        <BreadcrumbList>
                            <BreadcrumbItem>
                                <BreadcrumbLink href={"/"}>Affaires</BreadcrumbLink>
                            </BreadcrumbItem>
                        </BreadcrumbList>
                    </Breadcrumb>

                </div>
            </SectionPage>

            {/* Business & Leisure  */}
            <SectionPage sectionType="2xl">
                <AwesomeCard title={"Business & Leisure"} className={"bg-white text-muted-foreground"}
                             titleClassName={"text-bleu-marine"}>
                    La Côte d’Ivoire est une destination d’affaires qui depuis 2018 occupe la 3ème place en Afrique derrière le Maroc et le Nigéria.
<br /><br />
                    L’industrie touristique ivoirienne est en plein essor, particulièrement pour la niche prometteuse du tourisme d’affaires avec des perspectives prometteuses. Les gammes se diversifient depuis les hôtels budget jusqu’au haut de gamme offrant une large palette de choix.
                    <br /><br />

                    L’industrie Meetings Incentives Conferencing Exhibitions (MICE) en Côte d’Ivoire s’appuie sur des villes leaders telles que la capitale économique Abidjan, grand centre urbain moderne unique en son genre, Grand-Bassam ville côtière historique à l’architecture coloniale, Yamoussoukro carrefour du pays et ses établissements de standing savant alliage d’urbanité et de ruralité. Cette industrie a su faire du concept <span className={"font-bold italic"}>bleisure</span> (Business & Leisure) un de ses avantages pour des séjours d’affaires innovant, créatif, stimulant empreint de divertissement culturel.
                    <br /><br />
                    <br /><br />



                    Avec ses sites sous la protection de l’UNESCO, ses parcs nationaux, réserves naturelles, et de nombreux autres exemples d’un patrimoine culturel et naturel exceptionnel, la Côte d’Ivoire est l’un des plus beaux jardins d’Afrique de l’Ouest. Il est facilement accessible par avion, par les autoroutes modernes et par voie maritime. Le pays investit également massivement dans la sécurité (installation et extension d’un système de vidéosurveillance), qui est un autre de ses plus. L’Akwaba, son accueillante culture hospitalière, dès votre arrivée en Côte d’Ivoire donne le ton d’un séjour réussi et il n’est donc pas surprenant que le pays soit le choix de nombreux organisateurs de congrès, pour des réunions d’affaires et des programmes de team building et d’incentives d’envergure.

                </AwesomeCard>
            </SectionPage>

            {/* galerie */}
            <SectionPage sectionType="2xl">
                <AwesomeCard className={"bg-white"} titleClassName={"text-bleu-marine"}>
                    <div className={'mt-8'}>
                        <ImageGallery images={
                            Array.from({ length: 5 }).map((_, index) => ({
                                src: `/images/affaires/galerie/${index + 1}.jpg`,
                                alt: `affaire-${index + 1}`,
                                width: 700,
                                height: 700,
                            }))
                        } aspectRatio={"video"} />
                    </div>
                </AwesomeCard>
            </SectionPage>


        </div>
    );
}
